import React from 'react';
import Rotation from 'react-rotation';
import { isMobile } from 'react-device-detect';

import Bike360 from '../classes/Bike360';
import Estimation from './Estimation';

import { connect } from 'react-redux';
import classnames from 'classnames';

import { DEVICE } from '../constants/device';

const START_UPLOAD_TIMER = 500;
const SHOW_ROTATE_TIMEOUT = 3000;

// 360 rotation Component / estimation block
class Module360 extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            load360: false,
            loadImgs: false
        };
    }

    componentDidMount() {

        if (!isMobile) {
            // load all slides timer for rotation without freezes
            setTimeout(() => {
                this.setState(() => {
                    return { load360: true }
                })
            }, SHOW_ROTATE_TIMEOUT);

            // Starts loading 360
            setTimeout(() => {
                this.setState(() => {
                    return { loadImgs: true }
                })
            }, START_UPLOAD_TIMER);
        } else {
            // On mobile rotation without preloading, using touch
            this.setState({ load360: true })
        }

    }

    renderBike = (bikeRender360) => {
        const { load360 } = this.state;

        const get360DependsOnDevice = () => {
            return isMobile ? bikeRender360.getImages(DEVICE.MOBILE) : bikeRender360.getImages();
        }

        const cn = classnames('rotate-360-container', {
            active: load360,
            disabled: !load360
        })

        return <div className={cn}>
            {<Rotation
                autoPlay={this.props.play360}
                cycle={true}
                reverse={false}
                scroll={false}
                tabIndex={3}
            >
                {load360 ? get360DependsOnDevice() : [bikeRender360.getImages()[0]]}
            </Rotation>}
        </div>
    };

    render() {
        const { bike, color } = this.props;
        const { loadImgs, load360 } = this.state;

        const bikeRender360 = new Bike360(bike, color);
        return (
            <div className="rotate-360">
                <div className="lazy">
                    {loadImgs ? bikeRender360.getAllStartImgs() : null}
                </div>

                {this.renderBike(bikeRender360)}
                
                <Estimation 
                    load360={load360}
                />
            </div>
        )
    }
}

// REDUX STATES
const mapStateToProps = state => {
    return {
        play360: state.flags.play360,
        color: state.bike.color,
        bike: state.bike.bike,
    }
};

export default connect(mapStateToProps)(Module360)


// WEBPACK FOOTER //
// ./src/components/Rotate360.js